import { msg } from 'gt-react';
import { ClockIcon } from '@phosphor-icons/react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import the pathless parent; the cycle is EntityQuickFind → routeTree → routes.tsx → this module → route.tsx and already exists for every migrated route.
import { Route as pathlessAuthenticatedRoute, requireAdmin } from '../route';

const UserSessionsPage = lazyRouteComponent(
  () => import('./UserSessionsPage'),
  'UserSessionsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/user-sessions',
  staticData: {
    app: {
      nav: {
        label: msg('User Sessions', {
          context: 'sidebar nav label, Admin section',
        }),
        icon: <ClockIcon className="h-4 w-4" weight="fill" />,
        group: 'Admin',
        order: 81,
      },
      access: {
        adminOnly: true,
      },
    },
  },
  component: UserSessionsPage,
  loader: () => ({
    crumb: msg('User Sessions', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireAdmin({ context });
  },
});
